import React from "react";
import { useNavigate } from "react-router-dom";
import { Building2, FileCheck, Landmark, ArrowRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { IMAGES } from "../data/demo";
import { StatusPill } from "../components/Bits";

const ICONS = [Building2, FileCheck, Landmark];

export default function Business() {
  const { t } = useLang();
  const nav = useNavigate();
  return (
    <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-14" data-testid="business-page">
      <div className="grid md:grid-cols-2 gap-10 items-center">
        <div>
          <StatusPill status="coming" />
          <h1 className="font-display text-4xl sm:text-5xl text-white mt-3">{t("business.title")}</h1>
          <p className="text-white/60 mt-3">{t("business.sub")}</p>
          <button onClick={() => nav("/ask", { state: { prompt: "I want to start a consulting business in Dubai" } })}
            className="mt-6 inline-flex items-center gap-1 px-6 py-3 rounded-full bg-gold text-ink font-semibold hover:brightness-110 transition-all duration-200">
            {t("business.cta")} <ArrowRight size={16} />
          </button>
        </div>
        <div className="relative rounded-2xl overflow-hidden min-h-[300px]">
          <img src={IMAGES.business} alt="Dubai business district" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink to-transparent" />
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4 mt-14">
        {t("business.steps").map((s, i) => {
          const Icon = ICONS[i] || Building2;
          return (
            <div key={s.h} className="rounded-2xl bg-surface/60 border border-white/[0.06] p-6">
              <div className="w-10 h-10 rounded-lg bg-gold/10 text-gold flex items-center justify-center"><Icon size={18} /></div>
              <div className="font-display text-lg text-white mt-3">{s.h}</div>
              <div className="text-white/55 text-sm mt-1">{s.p}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
